export default __webpack_public_path__ + "static/media/Bangles.a023b32b.jpg";